module.exports = __webpack_public_path__ + "img/Logo_Doskomp.6225c088.png";